import $ from 'cash-dom';
import Popup from './../../components/popup';
import Device from './../../components/device';

$(() => {
    const sendClickEvent = (button) => {
        if (button.tagName === 'OBJECT' || button.tagName === 'DIV') {
            button = button.parentNode;
        }

        const $btn = $(button);
        const label = $btn.data('ga-label');
        const category = $btn.data('ga-category');

        if (typeof GAEvents !== 'undefined') {
            GAEvents.sendEvent(
                category ? category : 'ppc',
                'ai_review_click',
                label ? label : '',
            );
        }
    };

    const popup = new Popup({ cloneOriginalContent: true });

    popup.hide = function () {
        this._$fmPopup.addClass('hiding');

        setTimeout(() => {
            this._$fmPopup.attr('class', 'fm-popup');
            this._$fmPopup.hide();
            this._$popupContent.html(null);
            this._triggerPopupHide();
        }, 400);
    };

    $('.ai-summary-btn.mobile').on('click', (e) => {
        e.preventDefault();

        const content = $(e.currentTarget).siblings('.ai-summary-content').find('.ai-summary-content-holder');
        popup.show(content, 'ai-summary-mobile-popup');
    });

    const isVisible = (element) => {
        const el = element[0];
        if (!el) return false;

        const style = window.getComputedStyle(el);

        return style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            style.opacity !== '0' &&
            el.offsetWidth > 0 &&
            el.offsetHeight > 0;
    };

    $('.ai-summary-btn.desktop')
        .on('click', (e) => {
            e.preventDefault();

            if (Device.isTouch()) {
                const content = $(e.currentTarget).siblings('.ai-summary-content');
                const contentHolder = content.find('.ai-summary-content-holder');

                if (isVisible(contentHolder)) {
                    content.addClass('hidden-content');
                } else {
                    content.removeClass('hidden-content');
                }
            }
        }).on('mouseenter', (e) => {
            sendClickEvent(e.target);
        });
});
